import { Box, Typography } from "@mui/material";
import React from "react";

const MainSection = (props) => {
  // const nowMediaQuery = props.nowMediaQuery;

  return (
    <section className="section main_section">
      <div className="contents">
        <Box mt={"100px"}>
          <Typography
            variant="h4"
            className="bold"
            letterSpacing={2}
            mb={1}
            color={"white"}
            sx={{
              "text-shadow": "2px 3px 4px gray",
            }}
          >
            한 끼 식사로 시작된 인연이 따뜻한 위로가 되고,
            <br />
            함께 성장하는 공동체가 됩니다.
          </Typography>
          <Typography
            variant="h5"
            lineHeight={2}
            color={"white"}
            sx={{
              "text-shadow": "2px 3px 4px gray",
            }}
          >
            나눔이 만드는 따뜻한 변화에 함께 해주세요.
          </Typography>
        </Box>
      </div>
    </section>
  );
};

export default MainSection;
